import { useTranslation } from "react-i18next";

export default function SendButton({onClick, enabled, className}) {
    const { t } = useTranslation();

    return(<button 
                onClick={onClick} 
                className={`${!enabled ? "opacity-50" : "hover:bg-playmove-yellow hover:text-playmove-darkgray"} bg-playmove-darkgreen text-white w-[8rem] py-1 rounded-md ${className}`}>
					{t("send")}
				</button>)
}